import { Capacitor } from '@capacitor/core';

export const isNativeIOS = () => Capacitor.getPlatform() === 'ios';

export async function appleNativeLogin(api) {
  const { SignInWithApple } = await import('@capacitor-community/apple-sign-in');
  const ch = await api.post('/auth/apple/challenge');
  const { response } = await SignInWithApple.authorize({
    clientId: ch.data.client_id,
    redirectURI: '',
    scopes: 'email name',
    nonce: ch.data.nonce,
  });
  if (!response?.identityToken) {
    const err = new Error('no-identity-token');
    err.silent = true;
    throw err;
  }
  const res = await api.post('/auth/apple', {
    identity_token: response.identityToken,
    nonce: ch.data.nonce,
    given_name: response.givenName || null,
    family_name: response.familyName || null,
  });
  const { token } = res.data;
  localStorage.setItem('token', token);
  if (res.data.user?.email) localStorage.setItem('last_login_email', res.data.user.email);
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({ type: 'STORE_TOKEN', token });
  }
  return res.data;
}
